import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AuthModel } from './store/auth-model'
import { session_timer_reset } from './store/actions/auth-action-types'

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  constructor(private store: Store<AuthModel>) {}

  startIdleMonitor() {
    document.addEventListener('keydown', () => {
      this.store.dispatch(session_timer_reset())
    })

    document.addEventListener('click', () => {
      this.store.dispatch(session_timer_reset())
    })

    window.addEventListener(
      'message',
      (event: any) => {
        // Interaction between React iFrame to Angular parent frame
        if (event.data === 'refresh_angular_token') {
          this.store.dispatch(session_timer_reset())
        }
      },
      true
    )
  }
}
